var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5918 14.0918C26.5918 20.9954 20.9954 26.5918 14.0918 26.5918C7.18824 26.5918 1.5918 20.9954 1.5918 14.0918C1.5918 7.18824 7.18824 1.5918 14.0918 1.5918C20.9954 1.5918 26.5918 7.18824 26.5918 14.0918Z",
    stroke: "#A3A3A3",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3053_4013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.68976 18.0226L15.9807 8.60059L19.3862 11.4945L10.04 21.1049L6.37891 21.6097L6.68976 18.0226Z",
    fill: "#717070",
    stroke: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9443 10.8289L16.7163 8.01214L19.0218 5.51571L22.2796 8.33175L19.9443 10.8289Z",
    fill: "#717070",
    stroke: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79163 20.0551L10.0196 21.0579L6.35156 21.6434L6.77984 18.1101L7.69167 18.2043V18.9312V19.0725H7.83673H8.70711L8.74856 19.9137V20.0282H8.86599L9.79163 20.0551Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50421 21.482L9.85447 20.9436L9.68178 20.1831L8.59726 20.1225L8.542 19.1803L7.51965 19.2139V18.3188L6.87032 18.2515L6.50421 21.4752V21.482ZM6.19336 21.8252L6.69072 17.9622L7.85813 18.0766V18.9313L8.85976 18.8976L8.90811 19.8668L9.95809 19.9206L10.186 21.1522L6.19336 21.8252Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56542 20.3108L7.8019 21.3539L6.37891 21.603L6.56542 20.3108Z",
    fill: "#A3A3A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3053_4013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(6 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.de526bc7c8203a62c3e756f6a9d2eb23.svg";
export { ForwardRef as ReactComponent };